export const LOCAL_TRANSLATIONS_PATH = '/assets/i18n/';
